/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notification_Preference_Minute_Out_Of_RangeInputs */

const en_us2_notification_preference_minute_out_of_range = /** @type {(inputs: Notification_Preference_Minute_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That reminder time is not valid. Pick it again.`)
};

const pt_br2_notification_preference_minute_out_of_range = /** @type {(inputs: Notification_Preference_Minute_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse horário de lembrete não é válido. Escolha de novo.`)
};

const es_419_notification_preference_minute_out_of_range = /** @type {(inputs: Notification_Preference_Minute_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esa hora de recordatorio no es válida. Elígela de nuevo.`)
};

const pt_pt2_notification_preference_minute_out_of_range = /** @type {(inputs: Notification_Preference_Minute_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essa hora de lembrete não é válida. Escolhe-a outra vez.`)
};

const fr_fr2_notification_preference_minute_out_of_range = /** @type {(inputs: Notification_Preference_Minute_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette heure de rappel n'est pas valide. Choisis-la à nouveau.`)
};

const de_de2_notification_preference_minute_out_of_range = /** @type {(inputs: Notification_Preference_Minute_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Erinnerungszeit ist ungültig. Wähl sie noch mal.`)
};

const it_it2_notification_preference_minute_out_of_range = /** @type {(inputs: Notification_Preference_Minute_Out_Of_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'orario del promemoria non è valido. Sceglilo di nuovo.`)
};

/**
* | output |
* | --- |
* | "That reminder time is not valid. Pick it again." |
*
* @param {Notification_Preference_Minute_Out_Of_RangeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const notification_preference_minute_out_of_range = /** @type {((inputs?: Notification_Preference_Minute_Out_Of_RangeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notification_Preference_Minute_Out_Of_RangeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_notification_preference_minute_out_of_range(inputs)
	if (locale === "es-419") return es_419_notification_preference_minute_out_of_range(inputs)
	if (locale === "pt-PT") return pt_pt2_notification_preference_minute_out_of_range(inputs)
	if (locale === "fr-FR") return fr_fr2_notification_preference_minute_out_of_range(inputs)
	if (locale === "de-DE") return de_de2_notification_preference_minute_out_of_range(inputs)
	if (locale === "it-IT") return it_it2_notification_preference_minute_out_of_range(inputs)
	return en_us2_notification_preference_minute_out_of_range(inputs)
});
export { notification_preference_minute_out_of_range as "notification_preference.minute_out_of_range" }